import noop from 'lodash/noop';
import React, { useCallback } from 'react';
import Button from './Button';
import Modal from './Modal';
import ModalWrapper, { ModalWrapperProps } from './Modal/ModalWrapper';

type ConfirmationModalProps = ModalWrapperProps & {
  headerTitle: string;
  actionText?: string;
  action: () => void;
  onClose?: () => void;
};

const ConfirmationModal = ({
  action,
  actionText = 'Confirm',
  onClose: handleCloseModal = noop,
  headerTitle,
  headerDescription = '',
  ...restProps
}: ConfirmationModalProps) => {
  const handleAction = useCallback(() => {
    handleCloseModal();
    action();
  }, [handleCloseModal, action]);
  return (
    <ModalWrapper
      onClose={handleCloseModal}
      overlayStyle={{ zIndex: 500 }}
      showHeader={false}
      headerDescription={headerDescription}
      {...restProps}
    >
      <Modal.Header
        title={headerTitle}
        description={headerDescription}
        onClose={handleCloseModal}
        size="sm"
        className="mb-8"
      />
      <div className="mb-4 flex px-6 md:px-8 pb-6 md:pb-10">
        <Button block variant="primary" onClick={handleAction}>
          {actionText}
        </Button>
        <Button
          block
          variant="tertiary"
          className="text-gray-700"
          onClick={handleCloseModal}
        >
          Cancel
        </Button>
      </div>
    </ModalWrapper>
  );
};

export default ConfirmationModal;
